/// <reference path="WebService.ts" />

interface WebService
{
    adyenSignUp( paymentEntity:AdyenPaymentEntity, config:any, completion:any) : void ;
    adyenHOPLink( paymentEntity:AdyenPaymentEntity, completion:any) : void ;
}

WebService.prototype.adyenSignUp = function( paymentEntity:AdyenPaymentEntity, config:any, completion:any ) : void
{
    const url_str = this.paymentURL + "/adyen/schema/" + this.scheme + "/sign-up/" + paymentEntity.identifier;
    let r = new DLRequest ( url_str, config, "POST" );
    r.execute( completion );
}

WebService.prototype.adyenHOPLink = function( paymentEntity:AdyenPaymentEntity, completion:any ) : void
{
    const url_str = this.paymentURL + "/adyen/schema/" + this.scheme + "/generate-on-board-link/" + paymentEntity.identifier;
    let r = new DLRequest ( url_str );
    r.execute( completion );
}



